(function () {
  'use strict';

  angular.module('ringbaPortal')
    .filter('secondsToTextFormat', function(moment) {
      'ngInject';

      function pluralizeText(unit, time) {
        return time && time > 1 ? unit + 's' : unit;
      }

      return function(seconds){
        const duration = moment.duration(seconds, 'seconds'),
          secs = duration.seconds(),
          mins = duration.minutes(),
          hours = duration.hours(),
          days = duration.days();
        let text = '';

        text += (days ? days + ' ' + pluralizeText('day', days) + ' ' : '');
        text += (hours ? hours + ' ' + pluralizeText('hour', hours) + ' ' : '');
        text += (mins ? mins + ' ' + pluralizeText('min', mins) + ' ' : '');
        text += (secs ? secs + ' ' + pluralizeText('sec', secs) + ' ' : '');
        return text;
      };
    });
})();
